<article class="menu sidebar" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header class="header">
    <ng-container *ngIf="hasAdvertisement; then AdLayout else LogoLayout"></ng-container>
    <ng-template #AdLayout>
      <div class="advertisement">
        <ng-container *ngIf="isModeOne">
          <div class="logo">
            <img [src]="logo_image_path" class="ya_image">
          </div>
        </ng-container>
        <ng-container *ngIf="SOTAdvertisementViewModels.length > 1">
          <swiper class="swiper-container" [config]="adv_swiper_config" #AdvertisementSwiper>
            <div *ngFor="let adv of SOTAdvertisementViewModels" class="swiper-slide">
              <img *ngIf="adv.has_image" [src]="adv.image_path" (click)="navigationByAdvertisement(adv)"
                class="ya_image">
            </div>
          </swiper>
        </ng-container>
        <ng-container *ngIf="SOTAdvertisementViewModels.length === 1">
          <img *ngIf="SOTAdvertisementViewModels[0].has_image" [src]="SOTAdvertisementViewModels[0].image_path"
            (click)="navigationByAdvertisement(SOTAdvertisementViewModels[0])" class="ya_image">
        </ng-container>
      </div>
    </ng-template>
    <ng-template #LogoLayout>
      <div class="logo">
        <img [src]="logo_image_path" class="ya_image">
      </div>
    </ng-template>
  </header>
  <div class="navigation-container" [ngStyle]="useAltMenuColors() ? { 'background-color': '#807e71' } : {} ">
    <!-- #Itemgroup navigation tabs -->
    <div class="nav-buttons">
      <!--article tag filter button-->
      <ng-container *ngIf="isItemTagEnabled">
        <a class="btn filterTag" [class.filterTag-active]="hasTagFilterSelected" (click)="openFilterTagDialog()">
          <span langkey="main_set_filter"></span>
          <ng-container *ngIf="hasTagFilterSelected">
            <span>(<span>{{selectedTagFilterCount}}</span>)</span>
          </ng-container>
          <ng-container *ngIf="!isModeTwo">
            <div inlineSVG="sot/sot-icon.svg#sot-tagFilter" flex [setSVGAttributes]="{class: 'aside-icon'}"></div>
          </ng-container>
        </a>
      </ng-container>
      <!--scan coupon or redeem benefit-->
      <ng-container
        *ngIf="useCoupon && canDisplayRedeemBenefitBtn then combinedChoice else singleChoice"></ng-container>
      <ng-template #combinedChoice>
        <a class="btn coupon" (click)="openCombinedChoiceDialog()">
          <span langkey="main_benefit_redeem_title"></span>
        </a>
      </ng-template>
      <ng-template #singleChoice>
        <ng-container *ngIf="useCoupon">
          <a class="btn coupon" (click)="AddCoupon()">
            <span langkey="coupons_redeem"></span>
            <ng-container *ngIf="!isModeTwo">
              <div inlineSVG="sot/sot-icon.svg#sot-coupon" flex [setSVGAttributes]="{class: 'aside-icon'}"></div>
            </ng-container>
          </a>
        </ng-container>
        <ng-container *ngIf="canDisplayRedeemBenefitBtn">
          <a class="btn bonus" (click)="openScanVoucherToRedeemBenefit()">
            <span langkey="benefit_button_redeem"></span>
            <ng-container *ngIf="!isModeTwo">
              <div inlineSVG="sot/sot-icon.svg#sot-bonus" flex [setSVGAttributes]="{class: 'aside-icon'}"></div>
            </ng-container>
          </a>
        </ng-container>
      </ng-template>
    </div>
    <nav>
      <a class="swiper-button btn noborder" #NavigationPrevButton>
        <div inlineSVG="sot/sot-icon.svg#sot-backward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
      </a>
      <swiper class="swiper-container" [config]="navigationSliderconfig" #NavigationSwiper>
        <div class="slide" *ngFor="let itemGroup of SOTItemGroupViewModels">
          <a (click)="getActiveGroupAndScroll(itemGroup, $event)" [class.active]="activeItemGroup===itemGroup">
            <div class="img" *ngIf="!isModeTwo">
              <img *ngIf="itemGroup.model.has_image && itemGroup.model.image_path" [src]="itemGroup.model.image_path"
                alt="{{itemGroup.label}}" class="ya_image">
              <img
                *ngIf="!itemGroup.model.has_image && itemGroup.products && itemGroup.products.length > 0 && itemGroup.products[0].has_image && itemGroup.products[0].image_path"
                [src]="itemGroup.products[0].image_path" alt="{{itemGroup.label}}" class="ya_image">
              <div
                *ngIf="(!itemGroup.model.has_image || !itemGroup.model.image_path) && (!itemGroup.products || itemGroup.products.length === 0 || !itemGroup.products[0].has_image || !itemGroup.products[0].image_path)"
                inlineSVG="sot/sot-icon.svg#sot-image_error" [setSVGAttributes]="{class: 'ya_image'}">
              </div>
            </div>
            <div class="label" *ngIf="isModeTwo || !hideItemGroupLabel">
              {{itemGroup.label}}
            </div>
          </a>
        </div>
      </swiper>
      <a class="swiper-button btn noborder" #NavigationNextButton>
        <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
      </a>
    </nav>
  </div>

  <!--Itemgroup & products-->
  <div class="content" #product_list>
    <div class="section" *ngFor="let itemGroup of SOTItemGroupViewModels" id="itemgroup{{itemGroup.id}}">
      <div class="product-header" [class.has-description]="itemGroup.description">
        <h3 class="label">{{itemGroup.label}}</h3>
        <div class="description">{{itemGroup.description}}</div>
      </div>
      <a class="dish" *ngFor="let product of itemGroup.products" [class.noimg]="!product.has_image || isModeTwo"
        [class.nodesc]="!product.details.description &&(use_eCommerce &&(!hasBaseUnit(product.details.item_Base_Unit) && !product.details.hasContentLevel && !product.has_depositWithExtras))"
        [class.not-avail]="!product.schedule.active || !product.is_available"
        (click)="openProduct(product, itemGroup); $event.stopPropagation()">
        <div *ngIf="product.has_image && !isModeTwo" class="img">
          <img [src]="product.image_path" class="ya_image">
        </div>
        <div class="content container"
          [class.tag-enabled--direction]="isItemTagEnabled && product.product_tag_ids.length>0 && (!product.has_image)">
          <div class="top">
            <header>
              <h2>{{product.label}}</h2>
              <div class="preis">{{product.show_price | price}}</div>
            </header>
            <div *ngIf="product.details.description">
              <p class="truncatedText" [truncatedText]="product.details.description"></p>
            </div>
            <ng-container *ngIf="isItemTagEnabled">
              <div class="preferences">
                <div class="product-tag">
                  <div class="tag" *ngFor="let tag of GetProductTagsById(product.product_tag_ids)"
                    id=" productTag{{tag.id}}">
                    <div class="tag-svg" [innerHTML]="tag.svg_html"></div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <footer
            [class.footer-product-content]="product.depositWithExtras|| use_eCommerce&&(product.details.hasContentLevel|| hasBaseUnit(product.details.item_Base_Unit))">
            <div class="product-info">
              <ng-container *ngIf="product.has_depositWithExtras">
                <div class="deposit">
                  <span [langkey]="deposit_langkey"></span>
                  <span class="info-price--deposit">{{product.depositWithExtras | price:"p c" }} </span>
                </div>
              </ng-container>
              <ng-container *ngIf="use_eCommerce">
                <div class="product-content">
                  <ng-container *ngIf="product.details.hasContentLevel">
                    <ng-container *ngIf="product.details.alcohol_Content > 0">
                      <div class="product-content_level">
                        <span langkey="details_alcohol"></span>
                        <span class="content-level-value">{{product_alcoholContent(product.details.alcohol_Content) + "
                          %Vol."}}
                        </span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="product.details.caffeine_Content > 0">
                      <div class="product-content_level">
                        <span langkey="details_caffeine"></span>
                        <span class="content-level-value">{{product_caffeineContent(product.details.caffeine_Content) +"
                          mg"}}</span>
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="hasBaseUnit(product.details.item_Base_Unit)">
                    <div class="product-baseUnit">
                      <span
                        *ngIf="product.details.item_Base_Unit === baseUnit.PIECE">{{pricePerUnit(product.priceWithExtras,
                        product.details.item_Base_Factor) + " /1"}} <span
                          langkey="details_baseunit_piece"></span></span>
                      <span
                        *ngIf="product.details.item_Base_Unit === baseUnit.LITER">{{pricePerUnit(product.priceWithExtras,
                        product.details.item_Base_Factor) + " /1"}} <span
                          langkey="details_baseunit_liter"></span></span>
                      <span
                        *ngIf="product.details.item_Base_Unit === baseUnit.KILO">{{pricePerUnit(product.priceWithExtras,
                        product.details.item_Base_Factor) + " /1"}}<span langkey="details_baseunit_kilo"></span></span>
                    </div>
                  </ng-container>
                </div>
                <div *ngIf="product.details.prepackaged">
                  <span langkey="details_prepackaged"></span>
                </div>
              </ng-container>
            </div>
            <ng-container
              *ngIf="canAddDirectlytoCart(product);then addProductBtnTemplate else viewProductBtnTemplate"></ng-container>
            <ng-template #addProductBtnTemplate>
              <a class="btn insert btn--add"
                (click)="addToBasket(product,itemGroup); $event.stopPropagation();showBasketScrollArrow()">
                <div inlineSVG="sot/sot-icon.svg#sot-plus" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
              </a>
            </ng-template>
            <ng-template #viewProductBtnTemplate>
              <a class="btn insert">
                <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
              </a>
            </ng-template>
          </footer>
        </div>
        <ng-container *ngIf="!product.schedule.active && !isModeTwo">
          <div class="not-available">
            <span>{{product.schedule.hint}}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="product.schedule.active && !product.is_available && !isModeTwo">
          <div class="not-available">
            <span langkey="details_not_available"></span>
          </div>
        </ng-container>
      </a>
    </div>
    <!-- filter tag reset button-->
    <ng-container *ngIf="isItemTagEnabled && hasTagFilterSelected">
      <div class="tag-filter--reset">
        <h3 langkey="tags_reset_filter"></h3>
        <span langkey="tags_restore_filter_text"></span>
        <a class="btn clear" (click)="resetTagFilter()">
          <div inlineSVG="sot/sot-icon.svg#sot-close" flex [setSVGAttributes]="{class: 'icon-close'}"></div>
          <span langkey="tags_button_reset_filter"></span>
        </a>
      </div>
    </ng-container>
  </div>
  <div class="scroll-bottom" *ngIf="show_product_list_bottom_scroll" inlineSVG="sot/sot-icon.svg#sot-down_arrows"
    [setSVGAttributes]="{class: 'arrows'}"></div>
  <aside>
    <div class="service">
      <sot-langcall></sot-langcall>
      <button class="accessibility-button-menu btn" (click)="openAccessabiltyDialog()">
        <span langkey="ordertype_accessibility_btn"></span>
        <div class="icon">
          <svg viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 4C8.45 4 7.97917 3.80417 7.5875 3.4125C7.19583 3.02083 7 2.55 7 2C7 1.45 7.19583 0.979167 7.5875 0.5875C7.97917 0.195833 8.45 0 9 0C9.55 0 10.0208 0.195833 10.4125 0.5875C10.8042 0.979167 11 1.45 11 2C11 2.55 10.8042 3.02083 10.4125 3.4125C10.0208 3.80417 9.55 4 9 4ZM6 20V7C5 6.91667 3.98333 6.79167 2.95 6.625C1.91667 6.45833 0.933333 6.25 0 6L0.5 4C1.8 4.35 3.18333 4.60417 4.65 4.7625C6.11667 4.92083 7.56667 5 9 5C10.4333 5 11.8833 4.92083 13.35 4.7625C14.8167 4.60417 16.2 4.35 17.5 4L18 6C17.0667 6.25 16.0833 6.45833 15.05 6.625C14.0167 6.79167 13 6.91667 12 7V20H10V14H8V20H6Z" />
          </svg>
        </div>
      </button>
    </div>
    <div class="basket">
      <div class="basket-content" (click)="!is_basket_empty ? goToCheckout() : null"
        [class.has-items]="SOTBasketViewModel.getCount() > 0">
        <!--shopping cart -->
        <div class="basket--headline">
          <h3 langkey="main_basket"></h3><!--Warenkorb -->
        </div>
        <div class="basket--values">
          <div class="warenkorb" #basket_product_list [class.warenkorb-coupon--height]="useCoupon"
            [class.warenkorb-tagFilter--height]="isItemTagEnabled"
            [class.warenkorb-coupon-tagFilter--height]="useCoupon && isItemTagEnabled">
            <div class="basket-summary">
              <div class="basket-count-container">
                <div class="basket-icon">
                  <div inlineSVG="sot/sot-icon.svg#sot-hypersoft-warenkorb" flex
                    [setSVGAttributes]="{class: 'icon-basket'}"></div>
                </div>
                <span class="basket-count">{{SOTBasketViewModel.getCount() || 0}}</span>
              </div>
            </div>
          </div>
          <div class="amount">
            <div class="amount--sum">
              <p class="amount--sum-label">
                <span langkey="main_total"></span><!--Gesamtbetrag-->
              </p>
              <p class="amount--sum-value">
                <span class="preis">{{SOTBasketViewModel.getTotalSum() | price}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="buttons">
      <sot-processcard *ngIf="processCard" [amount]="cardUsedAmount" [limit]="processCard.limit">
      </sot-processcard>
      <div class="amount--buttons">
        <a (click)="!is_basket_empty ? goToCheckout() : null" [class.disabled]="is_basket_empty" class="btn action"
          langkey="button_order_now"></a><!--jetzt bestellen-->
        <a class="btn clear" (click)="openCancelDialog()"><span langkey="button_cancel"></span><!--abbrechen-->
          <div inlineSVG="sot/sot-icon.svg#sot-close" flex [setSVGAttributes]="{class: 'icon-close'}"></div>
        </a>
      </div>
    </div>

    <!--amount-->
  </aside>
</article>